module.exports = __webpack_public_path__ + "463eb6bdfe2b65c6fad76f705858a0f9.svg";